import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Search,
  Grid,
  Input,
  Icon,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { flashErrorMessage } from '../actions/flash';
import { fetchM } from '../actions/fetchM';
import { spaFullString } from '../utils/amount';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

class SearchProjectUnit extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    selectedValue: PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
    projectID: PropTypes.string.isRequired,
    hasAccess: PropTypes.bool.isRequired,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        currency: PropTypes.shape({
          symbol: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  }
  static defaultProps = {
    selectedValue: {
      key: 0,
      title: '',
    },
  }
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const value = props.value || '';
    const noResultsMessage = 'Loading...';
    return {
      value,
      noResultsMessage,
    };
  }
  constructor(props) {
    super(props);
    const state = SearchProjectUnit.getPropsToState(props);
    this.state = {
      ...state,
      findProjectUnitsResults: [],
      loading: false,
      showNoResults: true,
      selection: null,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = SearchProjectUnit.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  checkStatusID = (statusID, status) => {
    switch (statusID) {
      case 'developer_reserved':
        return 'Reserved';
      case 'developer_booked':
        return 'Booked';
      case 'developer_sold':
      case 'sold_spa_signed':
        return this.props.hasAccess ? 'Sold' : 'Booked';
      default:
        return status;
    }
  }
  async searchProjectUnits(value) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res = null;
    try {
      res = await store.dispatch(fetchM(`/search/project_units/?limit=30&projectID=${this.props.projectID}&search=${value}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const json = await res.json();
      if (json) {
        const findProjectUnitsResults = json.map((obj) => {
          const newResults = {};
          newResults.key = obj.id;
          newResults.title = `${obj.reference}, ${obj.projectUnitLayoutName}`;
          newResults.description = `${t('Size')}: ${obj.size} | ${t('Price')}: ${this.props.appConfig.data.currency.symbol}${spaFullString(obj, '000,000,000.00')}`;
          newResults.price = t(this.checkStatusID(obj.statusID, obj.status), { ns: TRANSLATION_FILES.constants });
          newResults.hrefLang = obj.statusID;
          newResults.className = obj.statusID !== 'new' ? 'unit-list-grey' : '';
          return newResults;
        });
        await this.setComponentState({ findProjectUnitsResults });
      } else {
        const noResultsMessage = `${t('No results found', { ns: TRANSLATION_FILES.translation })}.`;
        await this.setComponentState({ noResultsMessage });
      }
    }
    await this.setLoading(false);
  }
  handleSearchChange = (e, { value }) => {
    const { t } = this.props;
    clearTimeout(this.setTimer);
    const findProjectUnitsResults = [];
    const showNoResults = true;
    const noResultsMessage = `${t('Loading', { ns: TRANSLATION_FILES.translation })}...`;
    this.setState({ findProjectUnitsResults, noResultsMessage, showNoResults, value }, () => {
      if (value !== '') {
        this.setTimer = setTimeout(() => {
          this.searchProjectUnits(value);
        }, 500);
      }
    });
  }
  handleResultSelect = (e, { result }) => {
    let newSelection = result;
    if (result.price !== 'new') {
      newSelection = null;
    }
    this.setState({
      selection: newSelection,
      value: '',
    }, () => {
      this.props.onSelect(result);
    });
  }
  handleClearSelection = () => {
    this.setState({
      selection: null,
    }, () => {
      this.props.onClear();
    });
  }
  handlerClearValue = () => {
    this.setState({
      value: '',
    });
  }
  render() {
    const { t } = this.props;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            { this.props.selectedValue.key !== '' || this.state.selection ?
              <Grid>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Input
                      readOnly
                      fluid
                      value={
                        this.props.selectedValue.key !== ''
                        ? `${this.props.selectedValue.title}`
                        : `${this.state.selection.title}`
                      }
                      icon={
                        <Icon
                          title={t('Clear Selection')}
                          name="x"
                          onClick={this.handleClearSelection}
                          link
                        />
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            :
              <Grid>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Search
                      className="searchlist scrollresults"
                      fluid
                      icon={
                        <Icon
                          title={t('Clear Selection')}
                          name={this.state.value ? 'x' : 'search'}
                          onClick={this.state.value && this.handlerClearValue}
                          link={!!this.state.value}
                        />
                      }
                      loading={this.state.loading}
                      onResultSelect={this.handleResultSelect}
                      onSearchChange={this.handleSearchChange}
                      results={this.state.findProjectUnitsResults}
                      value={this.state.value}
                      placeholder={`${t('Search Project Unit')}...`}
                      noResultsMessage={this.state.noResultsMessage}
                      onFocus={() => {
                        const showNoResults = false;
                        this.setState({ showNoResults });
                      }}
                      showNoResults={this.state.showNoResults}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(connect(SearchProjectUnit.mapStateToProps)(SearchProjectUnit));



// WEBPACK FOOTER //
// ./src/components/SearchProjectUnit.jsx